import * as d3 from "d3";
import { AlarmLevel } from "../models/metMap/forecastResult";
import { ColorScale, ColorStyling } from "../styling/colorStyling";
export default class PowMonLimitZoneUtil {
    static init(limits, yFunc, chartSVG, chartYMax, chartHeight, chartWidth, forMainProgressBar = false) {
        let limitAbove = chartYMax;
        limits.forEach(limit => {
            const zone = chartSVG.append("rect")
                .attr("class", "limit-zone")
                .attr("x", 0)
                .attr("width", chartWidth);
            this.drawZone(zone, yFunc, limit, limitAbove, chartHeight, forMainProgressBar);
            limitAbove = limit.limit;
        });
    }
    static update(limits, selectAllLimitZones, chartYMax, yFunc, chartHeight, forMainProgressBar = false) {
        let limitAbove = chartYMax;
        selectAllLimitZones
            .data(limits)
            .each((limit, i, nodes) => {
            const zone = d3.select(nodes[i]);
            PowMonLimitZoneUtil.drawZone(zone, yFunc, limit, limitAbove, chartHeight, forMainProgressBar);
            limitAbove = limit.limit;
        });
    }
    static drawZone(zoneRect, yFunc, limit, limitAbove, chartHeight, forMainProgressBar = false) {
        const y = limit.limit > 0 ? yFunc(limitAbove) : yFunc(limit.limit);
        const height = limit.limit > 0 ? yFunc(limit.limit) - yFunc(limitAbove) : chartHeight - yFunc(limit.limit);
        const sFactor = limit.alarmLevel === AlarmLevel.AboveMax ? .8 : 0.4;
        let oFactor = limit.alarmLevel === AlarmLevel.AboveMax ? .5 :
            limit.alarmLevel === AlarmLevel.Alarm ? .3 : .2;
        if (!forMainProgressBar)
            oFactor = oFactor * .3;
        zoneRect
            .attr("y", y)
            .attr("height", height)
            .attr("fill", ColorStyling.hslModify(ColorStyling.alarmColor(limit.alarmLevel, ColorScale.Matt), sFactor, 1, oFactor).toString());
    }
}
